import { Component, ElementRef, EventEmitter, Input, OnInit, ViewChild, Output } from '@angular/core';
import { NgForm } from '@angular/forms';

import { ApiError, MessageService, ButtonLoader } from '../../../../core';
import { UnidadeNegocioFilter } from '../../filter';
import { unidadeNegocioAtiva } from '../../unidade-negocio-situacao';
import { UnidadeNegocio } from '../../unidade-negocio';
import { UnidadeNegocioPopula } from '../unidade-negocio-popula';
import { UnidadeNegocioPopulavel } from '../unidade-negocio-populavel';
import { UnidadeNegocioCrudHttpService } from '../../services';
import { classificacaoAtiva } from '../../../classificacao';
import { UsuarioUnidadeNegocioHttpService } from '../../../usuario/services/usuario-unidade-negocio-http.service';

@Component({
    selector: 'sgt-unidade-negocio-popula-modal',
    templateUrl: './unidade-negocio-popula-modal.component.html',
    styleUrls: ['./unidade-negocio-popula-modal.component.less']
})
export class UnidadeNegocioPopulaModalComponent implements OnInit {
    @Input() title = 'Adicionar unidades de negócios';
    @Input() subtitle = 'Selecione as unidades de negócios que deseja adicionar';
    @Input() searchByUsuarioLogado = true; // Se deve pesquisar somente as unidades de negócios que o usuário logado possui acesso
    @Input() entitiesAdicionadas: UnidadeNegocioPopulavel[];
    elModal: any;

    @ViewChild('form') form: NgForm;
    isLoading: boolean;
    isLoadingFinished: boolean;
    allSelected: boolean;
    entitiesPopula: UnidadeNegocioPopula[];

    @Output() adicionar = new EventEmitter<UnidadeNegocio[]>();

    constructor(private el: ElementRef,
                private messageService: MessageService,
                private unidadeNegocioCrudHttpService: UnidadeNegocioCrudHttpService,
                private usuarioUnidadeNegocioHttpService: UsuarioUnidadeNegocioHttpService) { }

    ngOnInit() {
        this.create();
    }

    /** Cria o modal */
    private create() {
        this.elModal = jQuery(this.el.nativeElement).find('.modal') as any;
        this.elModal
            .on('show.bs.modal', (e: any) => {
                e.stopPropagation();
            })
            .on('shown.bs.modal', (e: any) => {
                this.search();
                e.stopPropagation();
            })
            .on('hide.bs.modal', (e: any) => {
                e.stopPropagation();
            })
            .on('hidden.bs.modal', (e: any) => {
                e.stopPropagation();
            });
    }

    private clear() {
        this.entitiesPopula = [];
        this.allSelected = false;
        this.isLoadingFinished = false;
    }

    open() {
        this.clear();
        this.elModal.modal({keyboard: false, backdrop: 'static'});
    }

    close() {
        this.elModal.modal('hide');
    }
    /** Pesquisa as unidades de negócios */
    private search() {
        this.isLoading = true;
        this.isLoadingFinished = false;

       this.searchUnidadesNegocios()
            .then((unidadesNegocios) => {
                this.createPopula(unidadesNegocios)
                        .then(() => {
                            this.isLoading = false;
                            this.isLoadingFinished = true;
                        });
            })
            .catch(() => {
                this.isLoading = false;
                this.isLoadingFinished = true;
            });
    }

    /** Pesquisa as unidades de negócios ativas que o usuário logado possui acesso */
    private searchUnidadesNegociosUsuarioLogado(): Promise<UnidadeNegocio[]> {
        return new Promise<UnidadeNegocio[]>((resolve, reject) => {
            const situacoesUnidadesNegocios = [unidadeNegocioAtiva.id];
            const situacoesClassificacoes = [classificacaoAtiva.id];
            this.usuarioUnidadeNegocioHttpService.searchUnidadesNegociosUsuarioLogado(situacoesUnidadesNegocios, situacoesClassificacoes)
                .subscribe(
                    unidadesNegocios => resolve(unidadesNegocios),
                    (error: ApiError) => {
                        this.messageService.error(error.message, 'Erro ao pesquisar as unidades de negócios', error);
                        reject();
                    }
                );
        });
    }

    /** Pesquisa todas as unidades de negócios ativas */
    private searchAllUnidadesNegocios(): Promise<UnidadeNegocio[]> {
        return new Promise<UnidadeNegocio[]>((resolve, reject) => {
            const filter = new UnidadeNegocioFilter();
            filter.situacao = unidadeNegocioAtiva.id;
            this.unidadeNegocioCrudHttpService.searchWithFilter(filter)
                .subscribe(
                    unidadesNegocios => resolve(unidadesNegocios),
                    (error: ApiError) => {
                        this.messageService.error(error.message, 'Erro ao pesquisar as unidades de negócios', error);
                        reject(error);
                    }
                );
        });
    }

    /** Pesquisa as unidades de negócios conforme o paramêtro se é para pesquisar somente as que o usário logado possuo acesso ou todas cadastradas */
    private searchUnidadesNegocios(): Promise<UnidadeNegocio[]> {
        return new Promise<UnidadeNegocio[]>((resolve, reject) => {
            if (this.searchByUsuarioLogado) { // Unidades de negócios que o usuário logado possui acesso
                this.searchUnidadesNegociosUsuarioLogado()
                    .then(unidadesNegocios => resolve(unidadesNegocios))
                    .catch(error => reject(error));
            } else { // Todas as undiades de negócios
                this.searchAllUnidadesNegocios()
                    .then(unidadesNegocios => resolve(unidadesNegocios))
                    .catch(error => reject(error));
            }
        });
    }

    /** Cria os objetos utilizados para adicionar as unidades de negócios */
    private createPopula(unidadesNegocios: UnidadeNegocio[]): Promise<any> {
        return new Promise<void>((resolve) => {
            this.entitiesPopula = [];
            unidadesNegocios?.forEach(unidadeNegocio => {
                const entityPopula = new UnidadeNegocioPopula(unidadeNegocio);
                entityPopula.exists = this.isExists(unidadeNegocio.id);
                this.entitiesPopula.push(entityPopula);
            });

            resolve();
        });
    }

    /** Verifica se a unidade de negócio já existe nas unidades de negócios adicionadas informadas */
    private isExists(idUnidadeNegocio: number): boolean {
        if (!this.entitiesAdicionadas) {
            return false;
        }

        for (let i = 0; i < this.entitiesAdicionadas.length; i++) {
            const entityAdicionada = this.entitiesAdicionadas[i];
            if (entityAdicionada.idUnidadeNegocio === idUnidadeNegocio) {
                return true;
            }
        }

        return false;
    }

    /** Verifica se possui alguma unidade de negócio para popular */
    possuiUnidadesNegocios(): boolean {
        return this.entitiesPopula && this.entitiesPopula.length > 0;
    }

    /** Ao alterar a opção de selecionar todas as unidades de negócios */
    onChangeAllSelected(value: boolean) {
        this.entitiesPopula?.forEach(entityPopula => {
            if (!entityPopula.exists) {
                entityPopula.selected = value;
            }
        });
    }

    /** Ao alterar a seleção de uma unidade de negócio */
    onChangeSelected() {
        let allSelected = true;
        for (let i = 0; i < this.entitiesPopula?.length; i++) {
            const entityPopula = this.entitiesPopula[i];
            if (!entityPopula.selected && !entityPopula.exists) {
                allSelected = false;
                break;
            }
        }

        this.allSelected = allSelected;
    }

    /** Verifica se possui alguma unidade de negócio selecionada */
    private possuiAlgumaUnidadeNegocioSelecionada(): boolean {
        for (let i = 0; i < this.entitiesPopula?.length; i++) {
            const entityPopula = this.entitiesPopula[i];
            if (entityPopula.selected && !entityPopula.exists) {
                return true;
            }
        }

        return false;
    }


    /** Adiciona as unidades de negócios selecionadas */
    adicionarClick() {
        if (!this.possuiAlgumaUnidadeNegocioSelecionada()) {
            this.messageService.info('Selecione pelo menos uma unidade de negócio para adicionar ou clique em cancelar se não desejar adicionar nenhuma unidade de negócio', 'Informação');
            return;
        }

        const btn = new ButtonLoader('#btnAdicionarUnidadeNegocioPopulaModal');
        btn.loading('Adicionando');

        const entities: UnidadeNegocio[] = [];
        this.entitiesPopula?.forEach(entityPopula => {
            if (entityPopula.selected && !entityPopula.exists) {
                entities.push(entityPopula.unidadeNegocio);
            }
        });

        btn.reset();
        this.close();

        this.adicionar.emit(entities);
    }
}
